import src from "IMAGE";
export default { src, width: 1067, height: 575, blurWidth: 0, blurHeight: 0};
